import { LuSearch } from "@/Components/Icons/Icons";

export default {
  row1: [
  {
    column: "column1",
    rows: {
      row1: [
        {
          name: "exportProductDescription",
          label: "Product Description.",
          component: "text-field",
          type: "autocomplete",
          endpoint: "getDescription",
           required: true,
          icon: LuSearch,
          width:"50%"
        },
        {
          name: "Qty",
          component: "DateSelector",
          width:"25%",
        },
         {
          name: "unit",
          component: "text-field",
          width:"25%",
          endpoint: "getQuantity",
          type : "autocomplete"
        }
        
      ],
      row2: [
        {
          name: "exportUnitPrice",
          label:"Unit Price",
          component: "text-field",
          width: "25%",   
          },
           {
          name: "exportRitc",
          label:"RITC",
          component: "text-field",
          width: "25%",
          type: "autocomplete",
          endpoint: "getHsnCodeMaster"     
          },
          {
          name: "exportPmv",
          label:"PMV",
          component: "text-field",
          width: "25%",   
          },
          {
          name: "exportPmv",
          label:"PMV Currency",
          component: "dropdown",
          width: "25%",
          },
      ],
      row3: [
        {
          name: "exportEximScheme",
          label: "Exim Scheme",
          component: "text-field",
          width:"50%",
          dataType:"int"
        },
        {
          label: "exportNFEICategory",
          name: "NFEI Category",
          component: "dropDown",
          width:"50%",
          options: [
            { label: "Free Trade Sample", value: "Free Trade Sample" },
            { label: "Warranty Replacement", value: "Warranty Replacement" },
            { label: "Diplomatic Goods", value: "Diplomatic Goods" },
            { label: "Currency Chest", value: "Currency Chest" },
          ],
        }
      ],
      row4:[
        {
          name:"exportManufacturer",
          label:"Manufacturer",
          component: "text-field",
          width : "50%",
        },
         {
          name:"exportManufacAddrs",
          label:"ManufacAddrs",
          component: "text-field",
          width : "50%",
        }
      ],
      row5:[
        {
          name: "exportManufacCodeType",
          label: "Manufac Code Type",
          component: "text-field",
          width:"50%"
        },
          {
          name: "exportManufacCode",
          label: "Manufac Code",
          component: "text-field",
          width:"50%"
        },
      ],
      row6:[
        {
          name: "exportManufacCntry",
          label: "Manuf Cntry	",
          component: "text-field",
          width:"33%%",
        },
        {
          name: "exportManufacState",
          label: "Manuf State",
          component: "text-field",
          width:"33%%",
        },
        {
          name: "exportManufPostalCode",
          label: "Manuf PostalCode",
          component: "text-field",
          width:"33%%",
        },
      ],
      row7:[
        {
          name: "exportSourceState",
          label: "SourceState",
          component: "text-field",
          width:"50%"
        },
        {
          name: "exportTransitCntry",
          label: "TransitCntry",
          component: "text-field",
          width:"50%"
        },
      ],
      row8:[
        {
          name: "exportEndUse",
          label: "End Use",
          component: "text-field",
          width:"50%"
        },
        {
          name: "exportIGSTPayStat",
          label: "IGST Pay Stat	",
          component: "text-field",
          width:"50%"
        },
      ],
        row9:[
        {
          name: "exportIGSTTaxableAmt",
          label: "IGST Taxable Amt",
          component: "text-field",
          width:"50%"
        },
        {
          name: "exportIGSTRate",
          label: "IGST Rate",
          component: "text-field",
          width:"50%"
        },
      ],
       row10:[
        {
          name: "exportThirdpartyExpName",
          label: "Third party Exp Name",
          component: "text-field",
          width:"50%"
        },
        {
          name: "exportThirdpartyExpIECode",
          label: "Third party Exp IECode",
          component: "text-field",
          width:"50%"
        },
      ],
      row11:[
        {
          name: "exportThirdpartyExpBranchSNo	",
          label: "Third party Exp Branch SNo",
          component: "text-field",
          width:"33%"
        },
        {
          name: "exportThirdpartyExpIECode",
          label: "Third party Exp Reg Type",
          component: "dropdown",
          width:"33%"
        },
         {
          name: "exportThirdpartyExpRegNo",
          label: "Third party Exp Reg No",
          component: "text-field",
          width:"33%"
        },
      ],
      row12:[
        {
          name: "exportThirdPartyExpAddress",
          label: "Third party Exp Address",
          component: "text-field",
          width:"33%"
        },
        {
          name: "exportSQCQty",
          label: "SQC Qty",
          component: "dropdown",
          width:"33%"
        },
         {
          name: "exportSQCUnit",
          label: "SQC Unit",
          component: "text-field",
          width:"33%",
          type : "autocomplete",
          endpoint:"getQuantity"
        },
      ],
      row13:[
        {
          name: "exportCompCessRate",
          label: "Comp Cess Rate",
          component: "text-field",
          width:"33%"
        },
        {
          name: "exportPTA/FTAInfo",
          label: "PTA/FTA Info",
          component: "text-field",
          type : "autocomplete",
          endpoint:"getFTAMaster",
          width:"33%"
        },
         {
          name: "exportPerNoOfUnitsForItemRate",
          label: "PerNoOfUnitsForItemRate",
          component: "text-field",
          width:"33%",
        },
      ],
      row14:[
        {
          name: "exportRODTEPStatus",
          label: "RODTEP Status",
          component: "dropdown",
          width:"33%",
          options:[
            {label: "Yes",value : "Yes"},
            {label: "No",value : "No"},
            {label: "Not Applicable",value : "Not Applicable"}
          ]
        },
        {
          name: "exportRoDTEPQty",
          label: "RoDTEP Qty",
          component: "text-field",
          width : "33%"
        },
         {
          name: "exportRoDTEP Unit",
          label: "RoDTEP Unit",
          component: "text-field",
          width:"33%",
          type : "autocomplete",
          endpoint : "getQuantity"
        },
      ],
      row15:[
        {
          name: "exportMedicinalPlant",
          label: "Medicinal Plant",
          component: "text-field",
          width:"33%",
          disabled : true
        },
        {
          name: "exportFormulation",
          label: "Formulation",
          component: "text-field",
          width:"33%",
          disabled : true
                },
         {
          name: "exportSurfaceMaterialInContact",
          label: "Surface Material in Contact	",
          component: "text-field",
          width:"33%",
          disabled : true
        },
      ],
      row16:[
        {
          name: "exportGSTAllowed",
          label: "GST Allowed",
          component: "dropdown",
          width:"50%",
          options:[
            {label : "Yes",value : "Yes"},
            {label : "No",value : "No"}
          ]
        },
        {
          name: "exportLabGrownDiamond",
          label: "Lab Grown Diamond",
          component: "dropdown",
          width:"50%",
          disabled : true
         },
        
      ]
    },
  },
]
};